import React, { FC } from "react";
import Modal from "@mui/material/Modal";
import { classNames } from "repoV2/utils/common/render/classNames";
import styles from "./ModalStyles.module.scss";
import { IModalTypes } from "./IModal";

const DesktopModal: FC<IModalTypes.DesktopModalProps> = ({
    children,
    open,
    onClose,
    classes,
    ...rest
}) => {
    const { root: rootClass, ...restClasses } = classes || {};
    return (
        <Modal
            open={open}
            onClose={onClose}
            classes={{
                root: classNames(styles.modalRoot, rootClass),
                ...restClasses,
            }}
            {...rest}
        >
            {children}
        </Modal>
    );
};

export default DesktopModal;
